/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuditLogItemDto { 
    /**
     * Unique identifier
     */
    _id: string;
    /**
     * Idempotency key for deduplication
     */
    idempotencyKey?: string;
    /**
     * Stripe event ID
     */
    stripeEventId?: string;
    scope: AuditLogItemDto.ScopeEnum;
    action: AuditLogItemDto.ActionEnum;
    actorType: AuditLogItemDto.ActorTypeEnum;
    /**
     * Actor ID
     */
    actorId?: string;
    /**
     * Resolved display name of the actor
     */
    actorName?: string;
    entityType: AuditLogItemDto.EntityTypeEnum;
    /**
     * Entity ID
     */
    entityId: string;
    /**
     * Resolved display name of the entity
     */
    entityName?: string;
    /**
     * Amount change in cents
     */
    amountChange?: number;
    /**
     * Balance snapshot
     */
    balanceSnapshot?: object;
    /**
     * Previous state
     */
    previousState?: object;
    /**
     * New state
     */
    newState?: object;
    /**
     * Additional metadata
     */
    metadata?: object;
    /**
     * Timestamp of the audit event
     */
    timestamp: string;
    /**
     * Schema version
     */
    version: number;
}
export namespace AuditLogItemDto {
    export type ScopeEnum = 'transaction' | 'wallet' | 'platform' | 'admin_access' | 'organizer_access' | 'system';
    export const ScopeEnum = {
        Transaction: 'transaction' as ScopeEnum,
        Wallet: 'wallet' as ScopeEnum,
        Platform: 'platform' as ScopeEnum,
        AdminAccess: 'admin_access' as ScopeEnum,
        OrganizerAccess: 'organizer_access' as ScopeEnum,
        System: 'system' as ScopeEnum
    };
    export type ActionEnum = 'deposit_charged' | 'deposit_refunded' | 'deposit_released' | 'deposit_created' | 'deposit_failed' | 'escrow_hold' | 'escrow_release' | 'payout_initiated' | 'payout_completed' | 'payout_paid' | 'payout_failed' | 'payout_canceled' | 'connect_account_created' | 'bank_verification_changed' | 'transfer_confirmed' | 'earnings_recorded' | 'balance_sync' | 'balance_adjustment' | 'admin_read' | 'admin_write' | 'admin_delete' | 'organizer_read' | 'organizer_message' | 'system_cron' | 'system_reconciliation';
    export const ActionEnum = {
        DepositCharged: 'deposit_charged' as ActionEnum,
        DepositRefunded: 'deposit_refunded' as ActionEnum,
        DepositReleased: 'deposit_released' as ActionEnum,
        DepositCreated: 'deposit_created' as ActionEnum,
        DepositFailed: 'deposit_failed' as ActionEnum,
        EscrowHold: 'escrow_hold' as ActionEnum,
        EscrowRelease: 'escrow_release' as ActionEnum,
        PayoutInitiated: 'payout_initiated' as ActionEnum,
        PayoutCompleted: 'payout_completed' as ActionEnum,
        PayoutPaid: 'payout_paid' as ActionEnum,
        PayoutFailed: 'payout_failed' as ActionEnum,
        PayoutCanceled: 'payout_canceled' as ActionEnum,
        ConnectAccountCreated: 'connect_account_created' as ActionEnum,
        BankVerificationChanged: 'bank_verification_changed' as ActionEnum,
        TransferConfirmed: 'transfer_confirmed' as ActionEnum,
        EarningsRecorded: 'earnings_recorded' as ActionEnum,
        BalanceSync: 'balance_sync' as ActionEnum,
        BalanceAdjustment: 'balance_adjustment' as ActionEnum,
        AdminRead: 'admin_read' as ActionEnum,
        AdminWrite: 'admin_write' as ActionEnum,
        AdminDelete: 'admin_delete' as ActionEnum,
        OrganizerRead: 'organizer_read' as ActionEnum,
        OrganizerMessage: 'organizer_message' as ActionEnum,
        SystemCron: 'system_cron' as ActionEnum,
        SystemReconciliation: 'system_reconciliation' as ActionEnum
    };
    export type ActorTypeEnum = 'user' | 'admin' | 'system' | 'webhook';
    export const ActorTypeEnum = {
        User: 'user' as ActorTypeEnum,
        Admin: 'admin' as ActorTypeEnum,
        System: 'system' as ActorTypeEnum,
        Webhook: 'webhook' as ActorTypeEnum
    };
    export type EntityTypeEnum = 'transactions' | 'organizer_balances' | 'organizer_monthly_invoices' | 'platform_balances' | 'admin_routes' | 'userprofiles' | 'event_attendees' | 'wallets';
    export const EntityTypeEnum = {
        Transactions: 'transactions' as EntityTypeEnum,
        OrganizerBalances: 'organizer_balances' as EntityTypeEnum,
        OrganizerMonthlyInvoices: 'organizer_monthly_invoices' as EntityTypeEnum,
        PlatformBalances: 'platform_balances' as EntityTypeEnum,
        AdminRoutes: 'admin_routes' as EntityTypeEnum,
        Userprofiles: 'userprofiles' as EntityTypeEnum,
        EventAttendees: 'event_attendees' as EntityTypeEnum,
        Wallets: 'wallets' as EntityTypeEnum
    };
}


